import { render, staticRenderFns } from "./PaymentPaypal.vue?vue&type=template&id=46df9c9c&"
import script from "./PaymentPaypal.vue?vue&type=script&lang=js&"
export * from "./PaymentPaypal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports